import { render, staticRenderFns } from "./ItemStatus.vue?vue&type=template&id=345822a0&scoped=true"
import script from "./ItemStatus.vue?vue&type=script&lang=js"
export * from "./ItemStatus.vue?vue&type=script&lang=js"
import style0 from "./ItemStatus.vue?vue&type=style&index=0&id=345822a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345822a0",
  null
  
)

export default component.exports